import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { DayOff, Holiday, WorkingTime } from 'src/components';
import { Month } from 'src/components/Calendar/components';
import { HolidaysType, months } from 'src/constants/calendar';

interface YearViewProps {
  workTimePeriod: any;
  holidayPeriod: any;
  daysOffPeriod: any;
  yearState: number;
}

export const YearView = ({
  workTimePeriod,
  holidayPeriod,
  daysOffPeriod,
  yearState,
}: YearViewProps) => {
  const renderMonths = useCallback(() => {
    return months.map((month) => {
      return (
        <Month
          key={yearState + month}
          month={month}
          year={yearState}
          workTimePeriod={workTimePeriod}
          holidayPeriod={holidayPeriod}
          dayOffPeriod={daysOffPeriod}
        />
      );
    });
  }, [yearState, workTimePeriod, daysOffPeriod, holidayPeriod]);

  return (
    <Box sx={{
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      paddingLeft: '32px',
      paddingBottom: '54px',
    }}>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '1168px',
        padding: '0px 32px 32px 0px',
      }}>
        {
          renderMonths()
        }
      </Box>
    </Box>
  );
}
